export default __webpack_public_path__ + "static/media/la.ca715b06.svg";